module.exports = __webpack_public_path__ + "static/media/banner-with-margin.f9eab99c.webp";